export default "__VITE_ASSET__CYnIWJ67__"